import { Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';
import { currencify } from "../../helpers/common";
import { CommissionReportItem } from "../../models/reports.model";
import { Router } from "@angular/router";
import { ReportsService } from "../../services/reports.service";
import { ViewAsService } from '../../services/view-as.service';

@Component({
  selector: 'app-commissions-report-tile',
  templateUrl: './commissions-report-tile.component.html',
  styleUrls: ['./commissions-report-tile.component.scss']
})
export class CommissionsReportTileComponent implements OnInit {

  protected readonly currencify = currencify;

  @Input() item!: CommissionReportItem;
  @Input() kind!: 'Pending' | 'Paid';

  @HostBinding('attr.id') id!: string;

  readonly$ = this.viewAsService.readonly$;

  get dividerNeed() {
    const hostElement = this.el.nativeElement;

    if (!hostElement) {
      return false;
    }

    let nextNode = hostElement.nextSibling;

    while (nextNode && (nextNode.nodeType === Node.TEXT_NODE || nextNode.nodeType === Node.COMMENT_NODE)) {
      nextNode = nextNode.nextSibling;
    }

    if (!nextNode) {
      return false;
    }

    return nextNode.nodeName === 'APP-COMMISSIONS-REPORT-TILE';
  }

  get checked() {
    return this.reportsService.selectedCommissionIds.has(this.item.id);
  }

  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private viewAsService: ViewAsService,
    private el: ElementRef
  ) { }

  ngOnInit() {
    this.id = `${this.item.wId}_${this.item.pId}_${this.item.id}`;
    if (this.kind === 'Paid') {
      this.item.amount = this.item.paid;
      this.item.amount -= this.item.overpay && this.item.overpay < 0
        ? this.item.overpay
        : 0;
    }
  }

  async openPayment(wId: number, pId: number) {
    await this.router.navigate([`/payments/${wId}/${pId}`]);
  }

  check(checked: boolean, itemId: any) {
    if (checked && !this.reportsService.selectedCommissionIds.has(itemId))
      this.reportsService.selectedCommissionIds.add(itemId);

    if (!checked && this.reportsService.selectedCommissionIds.has(itemId))
      this.reportsService.selectedCommissionIds.delete(itemId);
  }
}
